
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderSaleReportGrid extends Serenity.EntityGrid<OrderSaleReportRow, any> {
        protected getColumnsKey() { return OrderSaleReportColumns.columnsKey; }
        protected getDialogType() { return OrderSaleReportDialog; }
        protected getIdProperty() { return OrderSaleReportRow.idProperty; }
        protected getInsertPermission() { return OrderSaleReportRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderSaleReportRow.localTextPrefix; }
        protected getService() { return OrderSaleReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderSaleReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;

        }
    }
}